import { Id, useLaravelDeleteEntity } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { eventsWidgetService } from "../dashboard/widgets/events/service";
import { clippingsService } from "../shared/api/clippingsService";
import { contactService } from "../shared/api/contactService";
import { archivedEventService } from "../shared/api/event/archivedEventService";
import { eventService } from "../shared/api/event/eventService";
import { eventUserRequestService } from "../shared/api/eventUserRequestService";

export const useDeleteEvent = (invalidateEventQuery: boolean = true) => {
	const { t } = useTranslation();
	const queryClient = useQueryClient();
	const deleteEntity = useLaravelDeleteEntity(
		eventService,
		{
			message: t("The event was successfully archived."),
			entityName: t("Events"),
		},
		[
			eventsWidgetService.key,
			clippingsService.indexKey,
			eventUserRequestService.approvedRequestsKey,
			eventUserRequestService.openRequestsKey,
			eventService.calendarKey,
			eventService.listOverviewKey,
			eventService.listKey,
			archivedEventService.listKey,
			contactService.indexKey,
		],
	);

	return useCallback(
		async (eventId: Id) => {
			const success = await deleteEntity(eventId);

			if (success) {
				if (invalidateEventQuery) {
					void queryClient.invalidateQueries({
						predicate: (query) => query.queryKey.includes("events") && !query.queryKey.includes(`${eventId}`),
					});
				}

				return true;
			}
			return false;
		},
		[deleteEntity, invalidateEventQuery, queryClient],
	);
};
